import { render, staticRenderFns } from "./ReportConsignment.vue?vue&type=template&id=1dd15733&scoped=true"
import script from "./ReportConsignment.vue?vue&type=script&lang=ts"
export * from "./ReportConsignment.vue?vue&type=script&lang=ts"
import style0 from "./ReportConsignment.vue?vue&type=style&index=0&id=1dd15733&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd15733",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd15733')) {
      api.createRecord('1dd15733', component.options)
    } else {
      api.reload('1dd15733', component.options)
    }
    module.hot.accept("./ReportConsignment.vue?vue&type=template&id=1dd15733&scoped=true", function () {
      api.rerender('1dd15733', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/ReportConsignment.vue"
export default component.exports